import { useBgFormContext } from "@app/guranteeFormWrapper";
import { GuaranteeInfo } from "./guaranteeInfo";
import { Lots } from "./lots";
import { StartFormBGInfo } from "./guaranteeInfo/startFormBGInfo";
import { PurchaseInfo } from "./purchase/purchaseInfo";

export const GuaranteeForm = () => {
  const { isStartForm } = useBgFormContext();

  return (
    <>
      {isStartForm ? <StartFormBGInfo /> : <GuaranteeInfo />}
      <PurchaseInfo />
      <Lots />
    </>
  );
};
